module.exports = __webpack_public_path__ + "hero-drag.f2e37abd.mp3";